/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
declare const _ReactionButtonContainer_comment$ref: unique symbol;
export type ReactionButtonContainer_comment$ref = typeof _ReactionButtonContainer_comment$ref;
export type ReactionButtonContainer_comment = {
    readonly id: string;
    readonly revision: {
        readonly id: string;
    } | null;
    readonly viewerActionPresence: {
        readonly reaction: boolean;
        readonly upvote: boolean;
        readonly downvote: boolean;
    } | null;
    readonly actionCounts: {
        readonly reaction: {
            readonly total: number;
        };
        readonly upvote: {
            readonly total: number;
        };
        readonly downvote: {
            readonly total: number;
        };
    };
    readonly " $refType": ReactionButtonContainer_comment$ref;
};



const node: ReaderFragment = (function () {
    var v0 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any), v1 = [
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "total",
            "args": null,
            "storageKey": null
        } as any)
    ];
    return {
        "kind": "Fragment",
        "name": "ReactionButtonContainer_comment",
        "type": "Comment",
        "metadata": null,
        "argumentDefinitions": [],
        "selections": [
            (v0 /*: any*/),
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "revision",
                "storageKey": null,
                "args": null,
                "concreteType": "CommentRevision",
                "plural": false,
                "selections": [
                    (v0 /*: any*/)
                ]
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "viewerActionPresence",
                "storageKey": null,
                "args": null,
                "concreteType": "ActionPresence",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "reaction",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "upvote",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "downvote",
                        "args": null,
                        "storageKey": null
                    }
                ]
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "actionCounts",
                "storageKey": null,
                "args": null,
                "concreteType": "ActionCounts",
                "plural": false,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "reaction",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ReactionActionCounts",
                        "plural": false,
                        "selections": (v1 /*: any*/)
                    },
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "upvote",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ReactionActionCounts",
                        "plural": false,
                        "selections": (v1 /*: any*/)
                    },
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "downvote",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ReactionActionCounts",
                        "plural": false,
                        "selections": (v1 /*: any*/)
                    }
                ]
            }
        ]
    } as any;
})();
(node as any).hash = 'e70104e17a398364cbab79ba14d2c82b';
export default node;
